export const OVERLAY_ACTIVE_DURATION = 3500;
